export const isSmallScreen = () => typeof window !== 'undefined' && window && window.innerWidth < 768;
